import { render, staticRenderFns } from "./informes-pendientes.vue?vue&type=template&id=42fd0028&scoped=true"
import script from "./informes-pendientes.vue?vue&type=script&lang=js"
export * from "./informes-pendientes.vue?vue&type=script&lang=js"
import style0 from "./informes-pendientes.vue?vue&type=style&index=0&id=42fd0028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd0028",
  null
  
)

export default component.exports